module.exports = "/fonts/Axis.ttf";